import { render } from "./resources.vue?vue&type=template&id=08312558&scoped=true"
import script from "./resources.vue?vue&type=script&lang=js"
export * from "./resources.vue?vue&type=script&lang=js"

import "./resources.vue?vue&type=style&index=0&id=08312558&lang=scss&scoped=true"
import "./resources.vue?vue&type=style&index=1&id=08312558&lang=scss"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08312558"]])

export default __exports__